import { VIEW, E_RISK_TYPE } from 'interfaces';
import { inject } from 'mobx-react';
import rootStore, { IMobxRootState } from 'RootStore';
import ChartContainer from 'components/GQChart/ChartContainer';
import useInitChart from 'hooks/useInitChart';
import useInitCountryDim from 'hooks/useInitCountryDim';
import { MultilateralRiskPage } from 'components/Pickers/MultilateralRiskPicker';
import { useEffect } from 'react';
import { COMPOSITE_DATA_INTERVAL } from 'components/GQChart/ChartStore';

type ContingentGraphPageProps = {
    countries?: number[];
};

type ContingentGraphProps = {
    height?: number;
    countries?: number[];
};

export const ContingentGraphPage = inject(
    ({ countryStore }: IMobxRootState) => {
        return {
            countries: countryStore.currentCountryList,
        };
    }
)(({ countries }: ContingentGraphPageProps) => {
    return (
        <MultilateralRiskPage>
            <ContingentGraph />
        </MultilateralRiskPage>
    );
});

export const ContingentGraph = inject(
    ({ chartStore, countryStore }: IMobxRootState) => {
        return {
            countries: countryStore.currentCountryList,
            height: chartStore.height,
        };
    }
)(({ height, countries }: ContingentGraphProps) => {
    useInitChart();
    const ready = useInitCountryDim({
        riskType: E_RISK_TYPE.CONTINGENT,
        multiCountry: true,
        multiRisk: false,
    });
    useEffect(() => {
        rootStore.chartStore.compositeDataInterval =
            COMPOSITE_DATA_INTERVAL.DAILY;
    }, []);
    if (!ready) {
        return null;
    }
    return (
        <ChartContainer
            height={height}
            activeView={VIEW.CONTINGENT_GRAPH}
            changeDataWhenDragStop={true}
        />
    );
});
